import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterSubscriptionVehicleStateSearchValueObject extends ValueObject {
  #vehicleState

  constructor({vehicleState}) {
    super()
    this.#vehicleState = vehicleState
  }

  static normalize(vehicleState) {
    return vehicleState === undefined ? null : vehicleState
  }

  static create({vehicleState}) {
    const normalizedVehicleState = FilterSubscriptionVehicleStateSearchValueObject.normalize(vehicleState)
    return new FilterSubscriptionVehicleStateSearchValueObject({
      vehicleState: FilterStringSearchValueObject.create({string: normalizedVehicleState})
    })
  }

  static createFromUrl({config, vehicleState, url = ''}) {
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const isRenting = url.startsWith('/renting/')

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.VEHICLE_STATE_USED)) {
      return FilterSubscriptionVehicleStateSearchValueObject.create({vehicleState: 'USED'})
    }

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.VEHICLE_STATE_NEW)) {
      return FilterSubscriptionVehicleStateSearchValueObject.create({vehicleState: 'NEW'})
    }

    const urlQueryParms = new URLSearchParams(url.split('?')[1] || '')
    if (urlQueryParms.has('vehicleState')) {
      return FilterSubscriptionVehicleStateSearchValueObject.create({vehicleState: urlQueryParms.get('vehicleState')})
    }

    return FilterSubscriptionVehicleStateSearchValueObject.createWithDefaultValue({
      config,
      vehicleState
    })
  }

  static createWithDefaultValue({config, vehicleState}) {
    return FilterSubscriptionVehicleStateSearchValueObject.create({vehicleState})
  }

  static createQueryParams({config, vehicleState}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')
    const normalizedVehicleState = FilterSubscriptionVehicleStateSearchValueObject.normalize(vehicleState)

    return new FilterSubscriptionVehicleStateSearchValueObject({
      vehicleState: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.VEHICLE_STATE],
        value: normalizedVehicleState
      })
    })
  }

  get isEmpty() {
    return this.#vehicleState?.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#vehicleState?.queryParam})
    }
  }

  get value() {
    return this.#vehicleState?.value
  }

  toJSON() {
    return {
      value: this.#vehicleState?.toJSON()
    }
  }
}
